import { Box, Typography, useTheme } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

interface FormHeaderProps {
  mode: 'create' | 'edit';
}

export function FormHeader({ mode }: FormHeaderProps) {
  const theme = useTheme();
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 }, mb: 3 }}>
      <PersonIcon sx={{ color: theme.palette.primary.main, fontSize: 36 }} />
      <Box>
        <Typography variant="h4" fontWeight={800} color={theme.palette.text.primary} mb={0.5}>
          {mode === 'create' ? 'Novo Organizador' : 'Editar Organizador'}
        </Typography>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Preencha as informações do Organizador.
        </Typography>
      </Box>
    </Box>
  );
}